import { useEffect } from 'react';

export const Redirect = () => {
  // 추후 병원 별 분리 필요해 보임.
  useEffect(() => {
    window.location.replace('http://plus.kakao.com/talk/bot/@가톨릭대학교서울성모병원/진료예약');
  }, []);
  return null;
};
